import { useMediaQuery } from './useMediaQuery';

/** Vrai en dessous du breakpoint `sm` (639px) — écran mobile. */
export function useMobileViewport(): boolean {
  return useMediaQuery('(max-width: 639px)');
}
